import $ from "jquery";
import LeftSideNav from "src/shared/navigation/LeftSideNav";

export default {
    start() {
        $(document.body).prepend(LeftSideNav.create());
    },
};
